import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import get from "../functions/get.js";
import Button from "../components/button.jsx";

export const ListLoader = ({url, buttonText, buttonRedirect, redirect}) => {

    const [ loading, setLoading ] = useState(false);
    const [ exercises, setExercises ] = useState([]);
    const [ error, setError ] = useState("");

    const onRes = (res, data) => {

        if (!res) {
            setError("Server nicht erreichbar!");
            return;
        }

        if (res.status === 200) {
            setLoading(false);
            setExercises(data);
        } else {
            setLoading(false);
            setError("Ein unerwarteter Fehler ist aufgetreten!")
        }

    };

    useEffect(() => {

        setLoading(true);
        get(url, onRes, onRes);

    }, []);

    if (error) {
        return (
            <div className="start-warning">
                <p>{error}</p>
            </div>
        );
    }

    return (
        <div>
            <div className="exercise-list">
                {!loading &&
                    <>
                        {exercises.map((e, idx) => {

                            let url;
                            let bg;

                            if (e.category === "Verben") {
                                url = "/images/verbs.png";
                                bg = "var(--yellow)";
                            } else if (e.category === "Nomen") {
                                url = "/images/nouns.png";
                                bg = "#2E8B57"
                            } else {
                                url = "/images/nouns.png";
                                bg = "var(--yellow)"
                            }

                            return (

                                <Link
                                to={`${redirect}/${e.id}`}
                                key={idx}
                                className="flex-row"
                                style={{marginTop: "20px", justifyContent: "flex-start", width: "100%"}}
                                >

                                    <div className="skeleton-circle" style={{background: bg}}>
                                        <img src={url} alt={`Logo für ${e.category}`}/>
                                    </div>

                                    <div className="flex-col">

                                        <div>
                                            {e.name || e.title}
                                        </div>

                                        <div>
                                            {[1, 2, 3, 4, 5].map((star) => (
                                                <span
                                                    key={star}
                                                    className={star <= e.difficulty ? "star filled" : "star"}
                                                >
                                                    ★
                                                </span>
                                            ))}
                                        </div>

                                    </div>


                                </Link>

                            );
                        })}
                    </>
                }

                {loading &&
                    <>
                        <div className="flex-row" style={{marginTop: "20px", justifyContent: "flex-start", width: "100%"}}>

                            <div className="skeleton skeleton-circle">

                            </div>

                            <div className="flex-col" style={{width: "calc(100% - 10px)"}}>

                                <div className="skeleton skeleton-box">

                                </div>

                                <div className="skeleton skeleton-box  box2">

                                </div>

                            </div>
                        </div>

                        <div className="flex-row" style={{marginTop: "20px", justifyContent: "flex-start", width: "100%"}}>

                            <div className="skeleton skeleton-circle">

                            </div>

                            <div className="flex-col" style={{width: "calc(100% - 10px)"}}>

                                <div className="skeleton skeleton-box">

                                </div>

                                <div className="skeleton skeleton-box  box2">

                                </div>

                            </div>
                        </div>
                    </>
                }
            </div>

            {(!loading && buttonText) &&
                <Link to={buttonRedirect}>
                    <Button className="button-yellow" text={buttonText} />
                </Link>
            }
        </div>
    );

};

export const DummyLoader = () => {

    return (
        <>

            <h2 className="skeleton skeleton-title"></h2>

            <p className="skeleton skeleton-text"></p>

            <div className="flex-row" style={{marginTop: "20px", justifyContent: "flex-start", width: "100%"}}>

                <div className="skeleton skeleton-circle">

                </div>

                <div className="flex-col" style={{width: "calc(100% - 10px)"}}>

                    <div className="skeleton skeleton-box box-big">

                    </div>

                    <div className="skeleton skeleton-box  box2">

                    </div>

                </div>
            </div>

            <div className="flex-row" style={{marginTop: "20px", justifyContent: "flex-start", width: "100%"}}>

                <div className="skeleton skeleton-circle">

                </div>

                <div className="flex-col" style={{width: "calc(100% - 10px)"}}>

                    <div className="skeleton skeleton-box box-big">

                    </div>

                    <div className="skeleton skeleton-box  box2">

                    </div>

                </div>
            </div>
        </>
    );

};